export const sliderData = [
    {
        title: 'Начните изучать языки с простых шагов',
        background: '#015091',
        color: '#C38611',
        img: './images/landing_page/scene_1.png'
    },
    {
        title: 'Развивайте словарный запас с помощью готовых подборок слов',
        background: '#5b6ec6',
        color: '#75C047',
        img: './images/landing_page/scene_2.png'
    },
    {
        title: 'Составляйте собственные карточки с набором слов и обменивайтесь ими с друзьями',
        background: '#9cc29a',
        color: '#846DB2',
        img: './images/landing_page/scene_3.png'
    },
    {
        title: 'Проходите тесты, следите за своей статистикой и делитесь ей с друзьями',
        background: '#12333e',
        color: '#CFB882',
        img: './images/landing_page/scene_4.png'
    }
]

export const tipsData = [
    {
        title: '🤷‍♂️ Не знаете с чего начать обучение? ',
        text: 'Мы собрали самые полезные правила и записали их в простой и интересной форме. Категории охватывают базовые и продвинутые разделы грамматики и лингвистики.'
    },
    {
        title: '✍ Надоело записывать слова ручкой?',
        text: 'Создавайте категории и добавляйте новые слова из фильмов и книг. А потом повторяйте их в любой момент времени.'
    },
    {
        title: '🤝 Уже есть команда единомышленников?',
        text: 'Приглашайте друзей, делитесь успехами, правилами и новыми словами. Выходите на новый уровень вместе.'
    }
]

export const cardsData = [
    {
        title: 'Карточки',
        text:
            'Учите слова с помощью эффективной методики карточек. Читаете английское слово, вспоминаете' +
            ' перевод и проверяете себя, переворачивая карточку',
        image: './images/mainpage/cards/cards.png'
    },
    {
        title: 'Тесты',
        text: 'Решайте тесты и закрепляйте результат',
        image: './images/mainpage/cards/test.png'
    },
    {
        title: 'Правила',
        text: 'Изучайте грамматику английского: начиная с базовых понятий и заканчивая правилами уровня Advanced',
        image: './images/mainpage/cards/grammar.png'
    },
    {
        title: 'Подборки слов',
        text:
            'Нет времени выписывать слова самому? У нас есть лучшие тематические подборки слов: базовые, продвинутые, ' +
            'разговорные, из лучших фильмов, сериалов и книг',
        image: './images/mainpage/cards/wordlist.png'
    },
    {
        title: 'Филворды',
        text:
            'Играйте и изучайте английский язык в игровой форме: мы подготовили игру, где необходимо искать слова на' +
            ' поле так, чтобы полностью заполнить квадрат',
        image: './images/mainpage/cards/scrabble.png'
    },
    {
        title: 'Статистика',
        text: 'Отслеживайте свои результаты: оцените прогресс и скорректируйте стратегию обучения',
        image: './images/mainpage/cards/statistic.png'
    }
]

export const wordCardsData = [
    {
        title: '🙋‍♂️ Местоимения',
        text: 'I – Я, You – Ты, He – Он, She – Она, They – Они...'
    },
    {
        title: '👕 Одежда',
        text: 'Shirt – Рубашка, Dress – Платье, Hat – Шляпа...'
    },
    {
        title: '🌦️ Погода',
        text: 'Rain – Дождь, Snow – Снег, Cloudy – Облачно...'
    },
    {
        title: '⚽ Спорт',
        text: 'Football – Футбол, Tennis – Теннис, Yoga – Йога...'
    },
    {
        title: '🍎 Еда и напитки',
        text: 'Apple – Яблоко, Bread – Хлеб, Water – Вода...'
    },
    {
        title: '🏠 Дом и мебель',
        text: 'Chair – Стул, Table – Стол, Window – Окно...'
    },
    {
        title: '✈️ Путешествия',
        text: 'Airport – Аэропорт, Ticket – Билет, Luggage – Багаж...'
    },
    {
        title: '🎨 Цвета и формы',
        text: 'Red – Красный, Circle – Круг, Square – Квадрат...'
    }
]

export const reviewsData = [
    {
        author: 'Никита',
        login: '_cyb3r_',
        text: 'Искал, как подтянуть английский, и случайно наткнулся на этот сайт. Зарегистрировался — и не пожалел ни секунды! Интерактивные упражнения, игры, особенно филворды — это просто бомба! Теперь учёба не в тягость, а в кайф. Очень рекомендую!',
        img: '../images/review/nikita.jpg'
    },
    {
        author: 'Илья',
        login: 'e-darya',
        text: 'Увидел ссылку на сайт в YouTube и зашёл просто из любопытства. А остался надолго! Тематические подборки слов из песен — это находка! Теперь не просто слушаю музыку, а реально прокачиваю словарный запас. Простой интерфейс и классный контент — must-have для всех, кто учит язык.',
        img: '../images/review/ilia.jpg'
    },
    {
        author: 'Влад',
        login: 'kost.ya62',
        text: 'Мечтал читать книги в оригинале без словаря. Раньше записывал слова в блокнот, таскал его с собой. Теперь всё это в прошлом! На сайте удобно сохранять новые слова и повторять их в любое время. За пару месяцев я реально начал читать на английском. Сайт — просто находка!',
        img: '../images/review/vlad.jpeg'
    }
]
